import Nav_module_default from "./Nav.module.js";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Nav/NavItem.tsx
var NavItemLink = forwardRef(function NavItemLink({ children, href, onClick, ...rest }, ref) {
	return /* @__PURE__ */ jsx("a", {
		href,
		onClick,
		className: Nav_module_default["nav-item"],
		...rest,
		ref,
		children
	});
});
var NavItemButton = forwardRef(function NavItemButton({ children, disabled, onClick, ...rest }, ref) {
	return /* @__PURE__ */ jsx("button", {
		onClick,
		className: Nav_module_default["nav-item"],
		disabled,
		ref,
		...rest,
		children
	});
});
var renderAsLink = (props) => "href" in props && !!props.href;
/**
* A navigation item component to be used with a navigation bar.
* Will render an anchor when href is provided, otherwise a button element.
*/
var NavItem = forwardRef(function NavItem(props, ref) {
	/**
	* For accessibility rules related to tabs,
	* see https://www.w3.org/WAI/ARIA/apg/patterns/tabs/#wai-ariaroles,states,andproperties
	*
	* For accessibility rules related to navigation,
	* see https://www.digitala11y.com/navigation-role/
	*/
	const ariaControls = props["aria-controls"];
	const a11yAttributes = !!ariaControls ? {
		"aria-controls": ariaControls,
		role: "tab",
		"aria-selected": props.active
	} : { "aria-current": props.active ? true : void 0 };
	const propsForChild = { ...props };
	delete propsForChild["active"];
	let navItem;
	if (renderAsLink(propsForChild)) {
		const buttonRef = ref;
		navItem = /* @__PURE__ */ jsx(NavItemLink, {
			...propsForChild,
			...a11yAttributes,
			ref: buttonRef
		});
	} else {
		const buttonRef = ref;
		navItem = /* @__PURE__ */ jsx(NavItemButton, {
			...propsForChild,
			...a11yAttributes,
			ref: buttonRef
		});
	}
	return /* @__PURE__ */ jsx("li", {
		className: Nav_module_default["nav-tab"],
		"data-current": props.active ? true : void 0,
		role: "presentation",
		children: navItem
	});
});
//#endregion
export { NavItem };

//# sourceMappingURL=NavItem.js.map